import CardInfo from './CardInfo'

const Home = () => {
  return (
    <>
      <CardInfo
        text={
          <>
            O mundo bruxo esteve por anos numa guerra contra Voldemort e seu
            fiel grupo de Comensais da Morte. Agora, seus seguidores caminham
            pelas sombras, assim como seu líder, que já está em silêncio há
            meses. Durante o mesmo tempo, já não se veem mais ataques grandes,
            desaparecimentos e mortes com a mesma frequência. Tudo aponta para
            um fim eminente da Primeira Guerra Bruxa, mas é como dizem, baixar a
            guarda é sempre perigoso. Os bruxos, no começo de seus vinte anos,
            tentam finalmente dar início a suas vidas adultas, buscando a
            tranquilidade e a paz que lhes seria assegurada na ausência daquele
            que não se deve nomear, mas até quando ela durará?
          </>
        }
      />
    </>
  )
}

export default Home
